import React, { useState, useRef, createRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { addDoc, collection, onSnapshot,getDocs, query, where  } from "firebase/firestore"
import { useAuthSolar } from '../../../setup/AuthContextSolar'
import appCheck from '../../../setup/Firebase';
import "./subscribe.css"
import { authSolar, dbSolar} from '../../../setup/FirebaseSolar'; // Import your Firebase instance

export default function SolarSubscribe() {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const hasActiveSubscription = async (uid) => {
    const subsRef = collection(dbSolar, "customers", uid, "subscriptions")
    const q = query(subsRef, where("status", "in", ["trialing", "active"]))
    const snap = await getDocs(q)
    return !snap.empty
  }

  const startCheckout = async () => {
    if (loading) return
    setLoading(true)
    const user = authSolar.currentUser
    if (!user || user.isAnonymous) {
      navigate("/Solar-Login", { replace: true })
      return
    }

    const alreadySubscribed = await hasActiveSubscription(user.uid)
    if (alreadySubscribed) {
      alert("You already have an active subscription")
      setLoading(false)
      return
    }

    const checkoutRef = await addDoc(
      collection(dbSolar, "customers", user.uid, "checkout_sessions"),
      {
        price: "price_1SyUL4FDo4ddpsZEfWW3IYwl",
        allow_promotion_codes: true,
        success_url: window.location.origin + "/Premium-Solar-Calculator",
        cancel_url: window.location.origin + "/Solar-Subscribe",
      }
    )

    onSnapshot(checkoutRef, (snap) => {
      const data = snap.data()
      if (data?.error) {
        alert("Something went wrong. Please try again")
        console.log(data?.error)
        setLoading(false)
      }
      if (data?.url) {
        window.location.assign(data.url)
      }
    })
  }
   return (
    <div className='emas__subscribe'>
      <div className='emas__subscribe-container'>
        <h1>Premium Solar Calculator Subscription</h1>
        <p>Includes our forecasts of electricity prices.</p>
        <p>Provides more accurate estimates of the costs that are avoided from investing in solar panels or batteries. </p>
        <p>Billed annually at $10/year incl GST</p>
        <button onClick={startCheckout} disabled={loading}>
          {loading ? "Redirecting to Stripe…" : "Subscribe with Stripe"}
        </button>
      </div>
    </div>
   );
}